import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
  useParams,
} from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "./contexts/authContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import AuthRedirectHandler from "./user_panel/components/AuthRedirectHandler";
import Layout from "./admin_panel/components/Layout";
import Events from "./admin_panel/pages/Events";
import News from "./admin_panel/pages/News";
import NewArrivals from "./admin_panel/pages/NewArrivals";
import AskLibrarian from "./admin_panel/pages/AskLibrarian";
import withAuth from "./WithAuth/WithAuth";
import LoginPage from "./user_panel/sign/LoginPage";
import Home from "./user_panel/pages/Home";
import Questions from "./user_panel/pages/Questions";
import Header from "./user_panel/components/Header";
import Footer from "./user_panel/components/Footer";
import AllNews from "./user_panel/pages/AllNews";
import NewsDetail from "./user_panel/pages/NewsDetail";
import BookDetail from "./user_panel/pages/BookDetail";
import RegisterPage from "./user_panel/sign/RegisterPage";
import "./user_panel/styles/index.css";
import MenuEditor from "./admin_panel/pages/MenuEditor";
import AdminPageBuilder from "./admin_panel/pages/AdminPageBuilder";
import PageBuilder from "./user_panel/pages/PageBuilder";
import EventDetailPage from "./user_panel/pages/EventDetail";
import AdminManagement from "./admin_panel/pages/AdminManagement";
import UserManagement from "./admin_panel/pages/UserManagement";
import PageEditor from "./admin_panel/pages/PageEditor";
import NotFound from "./user_panel/pages/NotFound";
import HeaderMobile from "./user_panel/components/HeaderMobile";
import UserProfile from "./user_panel/pages/UserProfile";
import AdminResupplyPanel from "./admin_panel/pages/AdminResupplyPanel";
import BooksSearchPage from "./user_panel/pages/Books";
import DirectorBlogPage from "./user_panel/pages/DirectorBlogPage";
import AllEvents from './user_panel/pages/AllEvents'

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const AdminLayout = () => (
  <Layout>
    <Outlet />
  </Layout>
);

const UserLayout = () => (
  <div className="user-layout">
    <Header />
    <HeaderMobile />
    <main className="user-content">
      <Outlet />
    </main>
    <Footer />
  </div>
);

// Admin 404 component that uses admin layout
const Admin404 = () => (
  <Layout>
    <NotFound />
  </Layout>
);

const ProtectedAdminLayout = withAuth(AdminLayout, ["admin"]);
const ProtectedAdmin404 = withAuth(Admin404, ["admin"]);

function PageWrapper() {
  const { slug } = useParams();
  const location = useLocation();

  return <PageBuilder key={location.pathname} slug={slug} />;
}

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AuthRedirectHandler>
            <ScrollToTop />
            <Routes>
              {/* User Panel */}
              <Route path="/" element={<UserLayout />}>
                <Route path="/pages/:slug" element={<PageWrapper />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route index element={<Home />} />
                <Route path="/questions" element={<Questions />} />
                <Route path="/news" element={<AllNews />} />
                <Route path="/news/:id" element={<NewsDetail />} />
                <Route path="/book/:id" element={<BookDetail />} />
                <Route path="/events" element={<AllEvents />} />
                <Route path="/events/:id" element={<EventDetailPage />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/books" element={<BooksSearchPage />} />
                <Route path="/blog-director" element={<DirectorBlogPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              {/* Admin Panel */}
              <Route path="/admin" element={<ProtectedAdminLayout />}>
                <Route index element={<Events />} />
                <Route path="news" element={<News />} />
                <Route path="new-arrivals" element={<NewArrivals />} />
                <Route path="ask-librarian" element={<AskLibrarian />} />
                <Route path="menu-editor" element={<MenuEditor />} />
                <Route path="page-editor" element={<PageEditor />} />
                <Route path="pages/:slug" element={<AdminPageBuilder />} />
                <Route path="admin-management" element={<AdminManagement />} />
                <Route path="user-management" element={<UserManagement />} />
                <Route path="resupply" element={<AdminResupplyPanel />} />
                <Route path="*" element={<ProtectedAdmin404 />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthRedirectHandler>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
